export default __webpack_public_path__ + "static/media/teaching_to_tech.81551572.png";